<template>
  <div>

    <b-row>
      <b-col>
        <h2><strong>Core Training (10 Full Modules):</strong></h2>
        <ul class="benefits">
          <li>✅ The Full Melani Method Framework – From Clarity → To Structure → To Professional Growth</li>
          <li>✅ Step-by-step guidance through:</li>
          <ul>
            <li>• Essential Oil Architecture</li>
            <li>• Formulation Framework</li>
            <li>• Client Work & Collaboration</li>
            <li>• Professional Communication</li>
            <li>• Advanced Techniques</li>
            <li>• Career Direction & Scaling</li>
          </ul>
          <li>✅ Biweekly Group Live Calls with Melani (3-months) & more personal time than future students will ever get</li>
          <li>✅ Lifetime Access + All Future Updates & Versions</li>
          <li>✅ A like-hearted community that values safety, clarity, and the art of practice</li>
        </ul>

        <h2 style="margin-top: 20px;"><strong>Plus… These High-Impact Bonuses (Over €2,100 Value!)</strong></h2>
        <ul class="benefits">
          <!--li> Private 1:1 Session with Melani (First 10 only)</li-->
          <li>✅ Essential Oil Conversion Calculator – €97 Value</li>
          <li>✅ Basic EO Chemistry PDF Guide – €47 Value</li>
          <li>✅ Power Drops Chemistry & Synergy Course – €750 Value</li>
          <li>✅ Blending Challenges + Swipe Files – €97 Value</li>
          <li>✅ Case Study Writing Guide – €147 Value</li>
          <li>✅ Drug Interactions Guest Lecture – €197 Value</li>
          <li>✅ Molecule Interaction & Chemical Behavior Lecture – €197 Value</li>
          <li>✅ Aromatherapy Research Pathways Lecture – €197 Value</li>
          <li>✅ Modern Cosmetics Expert Training Series – €350 Value</li>
          <li>✅ 3 Months of Dropsmart Premium Access – €57 Value</li>
        </ul>
      </b-col>
    </b-row>

    <h2 class="textMoneyback" v-if="this.routeName != 'GiftCard'">
      365-Day No-Questions-Asked Money-Back Guarantee
    </h2>
    <p class="text-riskFree" v-if="this.routeName != 'GiftCard'">
      You have <strong>365 days</strong> to ask for your money back. If you see that this is not for you, you can simply email us, and we will give your money back.
    </p>
  </div>
</template>

<style lang="scss">

ul.benefits {
  list-style: none;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.benefits li {
  margin-top: 10px;
  list-style: none;
  line-height: 28px;
  font-size: 18px;
}

.textMoneyback {
  color: #434343;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 19px;
  margin-top: 50px;
}

.text-riskFree {
  font-size: 18px;
  color: #434343;
  margin-bottom: 70px;
}

.testimonials {
  background: #f7f7f7;
  margin-bottom: 20px;
  padding: 40px 45px;
  img {
    margin-bottom: 25px;
    max-width: 80px;
  }
  p {
    color: #545454;
    font-size: 20px;
    line-height: 30px;
    img {
      margin: 0;
    }
  }
  .nomargin {
    margin: 0;
  }
  .testimonials-box {
    display: flex;
    align-items: center;
    img {
      align-self: center;
      margin-right: 30px;
    }
  }
  .testimonials-info {
    color: #545454;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    max-width: 300px;
    .testimonials-name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
}
</style>

<script>

export default {
  name: "NextLevelAromaEmpressLeft",
  props: ['routeName'],
}
</script>
